import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoPublicacionesDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoPublicacionesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoPublicacionesService(): Observable<BodyListResponse<CatalogoPublicacionesDTO>> {
    return this.http.get<BodyListResponse<CatalogoPublicacionesDTO>>(API_URL + '/api/v1/catalogoPublicaciones/todos');
  }

  guardarCatalogoPublicacionesService(catalogoPublicacionesDTO: CatalogoPublicacionesDTO): Observable<BodyResponse<CatalogoPublicacionesDTO>> {
    return this.http.post<BodyResponse<CatalogoPublicacionesDTO>>(API_URL + '/api/v1/catalogoPublicaciones', catalogoPublicacionesDTO);
  }

  getCatalogoPublicacionesPorCodigoCatalogoPublicacionesService(codigoCatalogoPublicaciones: string): Observable<BodyResponse<CatalogoPublicacionesDTO>> {
    return this.http.get<BodyResponse<CatalogoPublicacionesDTO>>(API_URL + '/api/v1/catalogoPublicaciones/' + codigoCatalogoPublicaciones);
  }
}
